import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed top-4 right-4 z-[60] flex flex-col gap-3 w-80 pointer-events-none" }
const _hoisted_2 = { class: "flex-shrink-0 mt-0.5" }
const _hoisted_3 = {
  key: 0,
  class: "w-5 h-5 text-success-500",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}
const _hoisted_4 = {
  key: 1,
  class: "w-5 h-5 text-error-500",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}
const _hoisted_5 = { class: "text-sm text-neutral-700 flex-1 leading-snug" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, {
        "enter-active-class": "transition duration-300",
        "enter-from-class": "opacity-0 translate-x-8",
        "enter-to-class": "opacity-100 translate-x-0",
        "leave-active-class": "transition duration-200",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0 translate-x-8"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toasts, (toast) => {
            return (_openBlock(), _createElementBlock("div", {
              key: toast.id,
              class: _normalizeClass(["pointer-events-auto bg-white rounded-xl shadow-lg border border-neutral-100 flex items-start gap-3 p-4 overflow-hidden", toast.type === 'success' ? 'border-l-4 border-l-success-500' : 'border-l-4 border-l-error-500'])
            }, [
              _createElementVNode("div", _hoisted_2, [
                (toast.type === 'success')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      }, null, -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                      }, null, -1)
                    ]))]))
              ]),
              _createElementVNode("p", _hoisted_5, _toDisplayString(toast.message), 1),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.dismiss(toast.id)),
                class: "flex-shrink-0 text-neutral-400 hover:text-neutral-600 transition-colors"
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ]))], 8, _hoisted_6)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}